<template>
  <div class="news_page">
    <header-bar></header-bar>

    <!-- 页头横幅 -->
    <div class="news_hero">
      <img
        class="news_hero_bg"
        :src="require('@/assets/banner_neural.jpg')"
        alt="般意 PanBrain 品牌蓝色神经网络球视觉背景"
      />
      <div class="news_hero_mask"></div>
      <div class="news_hero_inner">
        <div class="news_hero_title">新闻与投资者关系</div>
        <div class="news_hero_sub">让每一步进展都可以被查证</div>
      </div>
    </div>

    <!-- 公司里程碑 -->
    <div class="news_section news_white">
      <div class="section_title">公司里程碑</div>
      <img
        class="milestones_spine"
        src="../../assets/Milestones.png"
        alt="般意科技发展历程脊柱图"
      />
      <div class="timeline">
        <div class="timeline_item" v-for="item in milestones" :key="item.year">
          <div class="timeline_year">{{ item.year }}</div>
          <div class="timeline_dot"></div>
          <div class="timeline_events">
            <div
              class="timeline_event"
              v-for="(event, index) in item.events"
              :key="index"
            >
              {{ event }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 媒体报道 -->
    <div class="news_section news_gray">
      <div class="section_title">媒体报道</div>
      <div class="media_list">
        <template v-for="(report, index) in mediaReports">
          <a
            v-if="report.url"
            :key="index"
            class="media_card media_card_link"
            :href="report.url"
            target="_blank"
            rel="noopener"
          >
            <div class="media_top">
              <span class="media_outlet">{{ report.outlet }}</span>
              <span class="media_year">{{ report.year }}</span>
            </div>
            <div class="media_title">{{ report.title }}</div>
          </a>
          <div v-else :key="index" class="media_card">
            <div class="media_top">
              <span class="media_outlet">{{ report.outlet }}</span>
              <span class="media_year">{{ report.year }}</span>
            </div>
            <div class="media_title">{{ report.title }}</div>
          </div>
        </template>
      </div>
    </div>

    <!-- 投资者关系 -->
    <div class="news_section news_white">
      <div class="ir_card">
        <img
          class="ir_bg"
          :src="require('@/assets/wearing_scene.jpg')"
          alt="用户佩戴般意精力舱的场景图"
        />
        <div class="ir_mask"></div>
        <div class="ir_content">
          <div class="ir_title">商务合作与投资者关系</div>
          <div class="ir_text">
            商务合作与投融资洽谈：{{ contact.bdEmail }} ｜
            {{ company.fullName }} ｜ {{ contact.bdReplySla }}
          </div>
          <a class="ir_btn" :href="'mailto:' + contact.bdEmail">{{
            contact.bdEmail
          }}</a>
        </div>
      </div>
    </div>

    <!-- 公司概况速览 + Company Profile 下载 -->
    <div class="news_section news_white news_overview">
      <div class="section_title">公司概况速览</div>
      <div class="overview">
        <div class="overview_facts">
          <div class="fact_item">
            <span class="fact_value">{{ company.founded }} 年</span>
            <span class="fact_label">成立年份</span>
          </div>
          <div class="fact_item">
            <span class="fact_value">国家高新技术企业</span>
            <span class="fact_label">企业资质</span>
          </div>
          <div class="fact_item">
            <span class="fact_value">NMPA 二类医疗器械认证</span>
            <span class="fact_label">产品认证</span>
          </div>
          <div class="fact_item">
            <span class="fact_value">{{ keyFacts.unitsSold }} 台</span>
            <span class="fact_label">全球销量</span>
          </div>
          <div class="fact_item">
            <span class="fact_value"
              >{{ keyFacts.countries }} 个国家和地区</span
            >
            <span class="fact_label">覆盖国家</span>
          </div>
          <div class="fact_item">
            <span class="fact_value"
              >{{ founder.name }}（{{ founder.sciPapers }} 篇学术论文）</span
            >
            <span class="fact_label">创始人</span>
          </div>
        </div>
        <div class="profile_card">
          <div class="profile_title">Company Profile</div>
          <div class="profile_sub">一页式公司概况下载</div>
          <div class="profile_desc">
            适合媒体、合作伙伴与投资者快速了解般意科技的公司全貌、核心产品与资质认证。
          </div>
          <a
            class="profile_btn"
            href="/static/company-profile.pdf"
            target="_blank"
            rel="noopener noreferrer"
            download="般意科技简介-Company-Profile.pdf"
            >下载 Company Profile（PDF）</a
          >
        </div>
      </div>
    </div>

    <footer-info></footer-info>
  </div>
</template>

<script>
import headerBar from "@/components/common/HeaderBar";
import footerInfo from "@/components/common/FooterInfo";
import {
  company,
  keyFacts,
  milestones,
  mediaReports,
  contact,
  founder,
} from "@/data/facts";

export default {
  name: "News",
  data() {
    return {
      company,
      keyFacts,
      milestones,
      mediaReports,
      contact,
      founder,
    };
  },
  components: {
    headerBar,
    footerInfo,
  },
};
</script>

<style scoped>
.news_page {
  width: 100vw;
  background: #ffffff;
  font-family: "SourceHanSansCN-Regular", sans-serif;
}

/* 页头横幅 */
.news_hero {
  position: relative;
  width: 100vw;
  height: 26vw;
  overflow: hidden;
}

.news_hero_bg {
  display: block;
  width: 100vw;
  height: 26vw;
  object-fit: cover;
}

.news_hero_mask {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    180deg,
    rgba(11, 13, 68, 0.55) 0%,
    rgba(27, 30, 138, 0.35) 55%,
    rgba(11, 13, 68, 0.6) 100%
  );
}

.news_hero_inner {
  position: absolute;
  top: 7vw;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.news_hero_title {
  color: #ffffff;
  font-weight: bold;
  font-family: "SourceHanSansCN-Bold";
  font-size: 2.5vw;
  letter-spacing: 0.35vw;
  text-shadow: 0 0.15vw 1vw rgba(11, 13, 68, 0.55);
}

.news_hero_sub {
  color: #e3e5fb;
  font-weight: 500;
  font-family: "SourceHanSansCN-Medium";
  font-size: 1.25vw;
  margin-top: 1.3vw;
  letter-spacing: 0.12vw;
  text-shadow: 0 0.1vw 0.8vw rgba(11, 13, 68, 0.5);
}

/* 通用区块 */
.news_section {
  padding: 4.2vw 13.28vw;
}

.news_white {
  background: #ffffff;
}

.news_gray {
  background: #f7f8fa;
}

.section_title {
  text-align: center;
  color: #1b1e8a;
  font-weight: bold;
  font-family: "SourceHanSansCN-Bold";
  font-size: 2.5vw;
  margin-bottom: 3.2vw;
}

/* 公司里程碑时间轴 */
.milestones_spine {
  display: block;
  width: 56vw;
  height: 8.72vw;
  margin: -1.2vw auto 2.8vw;
}

.timeline {
  width: 56vw;
  margin: 0 auto;
}

.timeline_item {
  position: relative;
  display: flex;
  align-items: flex-start;
  padding-bottom: 2.4vw;
}

.timeline_item::before {
  content: "";
  position: absolute;
  left: 8.34vw;
  top: 0.7vw;
  bottom: -0.2vw;
  width: 0.12vw;
  background: linear-gradient(180deg, #888ef9 0%, #e3e5f7 100%);
}

.timeline_item:last-child {
  padding-bottom: 0;
}

.timeline_item:last-child::before {
  display: none;
}

.timeline_year {
  width: 6.6vw;
  text-align: right;
  color: #1b1e8a;
  font-weight: bold;
  font-family: "SourceHanSansCN-Bold";
  font-size: 1.5vw;
  line-height: 1.4;
}

.timeline_dot {
  position: relative;
  z-index: 1;
  flex-shrink: 0;
  width: 0.8vw;
  height: 0.8vw;
  border-radius: 50%;
  background: #888ef9;
  border: 0.18vw solid #e3e5f7;
  box-shadow: 0 0 0 0.22vw #ffffff;
  margin: 0.35vw 1.5vw 0 1.42vw;
}

.timeline_events {
  flex: 1;
}

.timeline_event {
  color: #333333;
  font-weight: 400;
  font-family: "SourceHanSansCN-Regular";
  font-size: 1.04vw;
  line-height: 1.8;
  background: #f7f8fa;
  border-radius: 0.5vw;
  padding: 0.7vw 1.3vw;
  margin-bottom: 0.5vw;
}

/* 媒体报道 */
.media_list {
  display: flex;
  justify-content: center;
  align-items: stretch;
}

.media_card {
  display: block;
  width: 22vw;
  margin: 0 0.9vw;
  background: #ffffff;
  border-radius: 0.83vw;
  padding: 1.8vw 1.6vw;
  text-decoration: none;
  box-shadow: 0 0.5vw 1.8vw rgba(27, 30, 138, 0.08);
}

.media_card_link {
  cursor: pointer;
}

.media_card_link:hover {
  box-shadow: 0 0.6vw 2.2vw rgba(27, 30, 138, 0.16);
}

.media_top {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.media_outlet {
  color: #1b1e8a;
  font-weight: bold;
  font-family: "SourceHanSansCN-Bold";
  font-size: 1.2vw;
}

.media_year {
  flex-shrink: 0;
  color: #888ef9;
  font-weight: 500;
  font-family: "SourceHanSansCN-Medium";
  font-size: 0.85vw;
  border: 1px solid #888ef9;
  border-radius: 0.9vw;
  padding: 0.12vw 0.7vw;
  margin-left: 0.8vw;
}

.media_title {
  color: #333333;
  font-weight: 400;
  font-family: "SourceHanSansCN-Regular";
  font-size: 0.94vw;
  line-height: 1.8;
  margin-top: 1vw;
}

/* 投资者关系卡 */
.ir_card {
  position: relative;
  width: 64vw;
  margin: 0 auto;
  background: #1b1e8a;
  border-radius: 1.04vw;
  overflow: hidden;
  text-align: center;
}

.ir_bg {
  position: absolute;
  top: 0;
  right: 0;
  width: 30vw;
  height: 100%;
  object-fit: cover;
  opacity: 0.35;
}

.ir_mask {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    90deg,
    rgba(27, 30, 138, 0.96) 30%,
    rgba(27, 30, 138, 0.75) 100%
  );
}

.ir_content {
  position: relative;
  z-index: 1;
  padding: 3.4vw 3vw;
}

.ir_title {
  color: #ffffff;
  font-weight: bold;
  font-family: "SourceHanSansCN-Bold";
  font-size: 1.9vw;
}

.ir_text {
  color: rgba(255, 255, 255, 0.9);
  font-weight: 400;
  font-family: "SourceHanSansCN-Regular";
  font-size: 1.04vw;
  line-height: 1.9;
  margin-top: 1.5vw;
}

.ir_btn {
  display: inline-block;
  margin-top: 2.2vw;
  background: #ffffff;
  color: #1b1e8a;
  font-weight: 500;
  font-family: "SourceHanSansCN-Medium";
  font-size: 1.1vw;
  padding: 0.85vw 3.2vw;
  border-radius: 2.2vw;
  text-decoration: none;
  box-shadow: 0 0.4vw 1.4vw rgba(11, 13, 68, 0.35);
}

.ir_btn:hover {
  background: #888ef9;
  color: #ffffff;
}

/* 公司概况速览 */
.news_overview {
  padding-top: 0;
}

.overview {
  display: flex;
  justify-content: center;
  align-items: stretch;
}

.overview_facts {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-content: stretch;
  width: 40vw;
  margin-right: 3vw;
}

.fact_item {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 19.2vw;
  box-sizing: border-box;
  background: #f7f8fa;
  border-radius: 0.6vw;
  padding: 1.4vw 1.6vw;
  margin-bottom: 1.2vw;
}

.fact_value {
  color: #1b1e8a;
  font-weight: bold;
  font-family: "SourceHanSansCN-Bold";
  font-size: 1.3vw;
  line-height: 1.5;
}

.fact_label {
  color: #9b9b9b;
  font-weight: 400;
  font-family: "SourceHanSansCN-Regular";
  font-size: 0.9vw;
  margin-top: 0.5vw;
}

.profile_card {
  width: 28vw;
  box-sizing: border-box;
  background: #f7f8fa;
  border-radius: 1.04vw;
  text-align: center;
  padding: 2.4vw 2.2vw;
  box-shadow: 0 0.5vw 1.8vw rgba(27, 30, 138, 0.07);
}

.profile_title {
  color: #1b1e8a;
  font-weight: bold;
  font-family: "SourceHanSansCN-Bold";
  font-size: 1.5vw;
}

.profile_sub {
  color: #333333;
  font-weight: 500;
  font-family: "SourceHanSansCN-Medium";
  font-size: 1.04vw;
  margin-top: 0.8vw;
}

.profile_desc {
  color: #666666;
  font-weight: 400;
  font-family: "SourceHanSansCN-Regular";
  font-size: 0.94vw;
  line-height: 1.8;
  margin-top: 1.2vw;
}

.profile_btn_disabled {
  display: inline-block;
  margin-top: 2vw;
  background: #e5e5ea;
  color: #9b9b9b;
  font-weight: 500;
  font-family: "SourceHanSansCN-Medium";
  font-size: 1vw;
  padding: 0.7vw 2vw;
  border-radius: 2vw;
  cursor: not-allowed;
}

.profile_btn {
  display: inline-block;
  margin-top: 2vw;
  background: #888ef9;
  color: #ffffff;
  font-weight: 500;
  font-family: "SourceHanSansCN-Medium";
  font-size: 1vw;
  padding: 0.7vw 2vw;
  border-radius: 2vw;
  cursor: pointer;
}

.profile_btn:hover {
  background: #1b1e8a;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/News.vue